import { useEffect, useState, type RefObject } from 'react';

export function useReveal(
  ref: RefObject<Element | null>,
  options: IntersectionObserverInit = { threshold: 0, rootMargin: '0px' },
): boolean {
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        setInView(true);
        obs.disconnect();
      }
    }, options);
    obs.observe(el);
    return () => obs.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref, options.threshold, options.rootMargin]);
  return inView;
}
